import Text from '@/components/text';
import { Divider, Stack } from '@mui/material';
import { FC } from 'react';

interface Props {
  label: string;
}

const DrawerFormSection: FC<Props> = ({ label }) => {
  return (
    <Stack gap={0.5} mt={2} mb={1}>
      <Text bold>{label}</Text>
      <Divider />
    </Stack>
  );
};

export default DrawerFormSection;
